const ErmsUrl = "https://pxbls.1v1jy.com";
// const ErmsUrl = "https://pxbls.getdreamstar.com";
// const ErmsUrl = "https://pxbls.yidiantangedu.com";
// const ErmsUrl = "https://pxbls.yiqun169.com";

export default {
  ErmsUrl
};



// WEBPACK FOOTER //
// ./src/api/etmsConfig.js